import React from 'react';
import { FaHardHat, FaBuilding } from 'react-icons/fa';
import { motion } from 'framer-motion';
import img from '../../assets/images/steel-structure-new-factory-geometric-shape-iron-pattern-roof-abstract-background.jpg'; // make sure this image exists

const PEBStructure = () => {
  return (
    <div className="w-full min-h-[600px] bg-white flex flex-col md:flex-row items-center justify-between px-6 md:px-20 py-12 gap-10">
      
      {/* Text Section */}
      <motion.div
        initial={{ opacity: 0, x: -80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        viewport={{ once: true }}
        className="flex-1 max-w-xl"
      >
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
          Excellence in PEB Structure Construction
        </h2>
        <p className="text-gray-600 text-lg mb-6">
          With years of expertise, LABH Industries delivers precision-engineered PEB structures(Pre Engineered Building Structues) that stand tall with durability and speed. From industrial sheds to large-scale warehouses, we redefine construction efficiency.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-6">
          <div className="flex items-center gap-4">
            <div className="bg-[#e6b127] text-white p-4 rounded-full shadow-md">
              <FaHardHat size={28} />
            </div>
            <div>
              <h4 className="font-semibold text-gray-800 text-lg">Smart Engineering</h4>
              <p className="text-sm text-gray-600">Modern tools for flawless design & execution.</p>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <div className="bg-[#5bc0fe] text-white p-4 rounded-full shadow-md">
              <FaBuilding size={28} />
            </div>
            <div>
              <h4 className="font-semibold text-gray-800 text-lg">Built to Last</h4>
              <p className="text-sm text-gray-600">Long-lasting structures with top-grade steel.</p>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Image Section */}
      <motion.div
        initial={{ opacity: 0, x: 80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        viewport={{ once: true }}
        className="flex-1"
      >
        <img
          src={img}
          alt="PEB Structure"
          className="w-full h-full max-h-[500px] object-cover rounded-xl shadow-lg"
        />
      </motion.div>
    </div>
  );
};

export default PEBStructure;
